import { render, staticRenderFns } from "./matching.vue?vue&type=template&id=a09f1d9a&scoped=true&"
import script from "./matching.vue?vue&type=script&lang=js&"
export * from "./matching.vue?vue&type=script&lang=js&"
import style0 from "./matching.vue?vue&type=style&index=0&id=a09f1d9a&prod&scoped=true&lang=css&"
import style1 from "./matching.vue?vue&type=style&index=1&id=a09f1d9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09f1d9a",
  null
  
)

export default component.exports